import { FC, useEffect, useState } from "react";
import { Loading } from "../../../components/Loading";

import "./index.css";
import { usePluginspace } from "../../../hooks/usePluginspace";
import useAuth from "../../../hooks/useAuth";
import api from "../../../services/api";
import { AddressCard } from "../../../components/Address/addressCard";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";

export type address = {
  id: number;
  customerId: number;
  typeAddress: string;
  street: string;
  number: string;
  district: string;
  complement: string;
  city: string;
  extra?: string;
  state: string;
  zipCode: string;
  ibgeCode: string;
  latlng?: any;
  placeId?: string;
  created?: string;
  updated?: string;
};

const AddressesIndex: FC = () => {
  const [loading, setLoading] = useState(false);
  const [addresses, setAddresses] = useState<address[]>([]);
  const navigate = useNavigate();

  const { getToken } = usePluginspace();
  const { loginInfo } = useAuth();

  const loadAddresses = async () => {
    if (loginInfo.identifier) {
      setLoading(true);

      await api
        .post(
          `/api/customer/filter`,
          {
            cpf: loginInfo.identifier,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response: any) => {
          setLoading(false);
          if (response.data.data.length > 0) {
            const data = response.data.data[0];
            setAddresses(data.customerAddresses);
          }
        })
        .catch((err: any) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  const cadastrarAddress = () => {
    navigate("create");
  };

  const deleteAddress = async (addressId: number) => {
    setLoading(true);
    try {
      await api
        .delete(`/api/customer/address/${loginInfo.id}/${addressId}`, {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        })
        .then(async (response: any) => {
          setLoading(false);

          if (response.data.success) {
            Swal.fire({
              icon: "success",
              title: "Sucesso!",
              text: "Endereço deletado com sucesso",
            });
            const newAddress = addresses.filter((el) => el.id !== addressId);

            setAddresses(newAddress);
          } else {
            Swal.fire({
              icon: "warning",
              title: "Erro!",
              text: "Não foi possivel excluir esse endereço!",
            });
          }
        })
        .catch((err: any) => {
          setLoading(false);
          console.log(err);
        });
    } catch (error) {
      console.log(error);
      setLoading(false);
      return;
    }
  };

  useEffect(() => {
    loadAddresses();
  }, [loginInfo]);

  return (
    <>
      {loading ? (
        <>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </>
      ) : (
        <div className="AddressContent">
          <div className="headerAddress">
            <h4>Endereços cadastrados</h4>
          </div>
          <div className="addresses">
            {addresses.map((add) => (
              <AddressCard data={add} deleteAddress={deleteAddress} />
            ))}
          </div>
          <div className="buttonField">
            <button
              style={{
                background: "#6E7586",
                color: "white",
                border: "none",
              }}
              onClick={() => cadastrarAddress()}
            >
              <span>Adicionar endereço</span>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export { AddressesIndex };
